import React from 'react'

function Orderpage() {
  return (
    <div>Orderpage</div>
  )
}

export default Orderpage